import { KlaviyoPopupAdapter } from '../adapters/klaviyo';
import { Popup } from '../popup';
import { PopupSniffer } from '../types';

export class KlaviyoSniffer implements PopupSniffer {
  sniff(): boolean {
    try {
      const observerCallback = (mutations: MutationRecord[]) => {
        // Check each addedNode for [data-testid="klaviyo-form-"]
        for (const mutation of mutations) {
          if (mutation.addedNodes.length === 0) continue;
          mutation.addedNodes.forEach((node) => {
            if (node instanceof HTMLElement) {
              const form: HTMLElement | null = node.querySelector('[data-testid^="klaviyo-form-"]');
              if (form) {
                this.onDetect(form);
              }
            }
          });
        }
      };

      const observer = new MutationObserver(observerCallback);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return true;
    } catch (e) {
      console.error('KlaviyoSniffer::sniff failed', e);
      return false;
    }
  }

  onDetect(element: HTMLElement): void {
    console.debug('KlaviyoSniffer::onDetect triggered!');
    if (!element) return;

    const klaviyoId = element.dataset?.testid?.replace(/^klaviyo-form-/, '');

    if (!klaviyoId) return;

    if (window.popupMonitor.getPopup(klaviyoId)) return;

    const adapter = new KlaviyoPopupAdapter({ id: klaviyoId });
    const rootElement = adapter.getRootElement();

    if (!rootElement) return;

    const newPopup = new Popup(adapter, {
      id: klaviyoId,
      initiallyVisible: true,
      priority: (window.popupMonitor.getPopups()?.size ?? 0) * -1,
      onClose: (popup) => {
        console.debug(`Klaviyo popup ${popup.getId()} was closed`);
      },
    });

    window.popupMonitor.addPopup(newPopup);
  }

  stop(): boolean {
    return false;
  }
}
